var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_c('confirm',{attrs:{"titleTig":_vm.titleTig,"message":_vm.message,"okText":_vm.okText,"shows":_vm.show},on:{"confirmok":_vm.confirmok}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }